import React, { useState } from 'react'
import { Input, notification } from 'antd'
import { AbstractSearchById } from '../../containers/onlineAbstract/views/actions'
import { getPushPathWrapper } from '../../routes'
import { useDispatch } from 'react-redux'

const AbstractSearch = (props) => {
  let [abstractNo, setAbstractNo] = useState('')
  let dispatch = useDispatch()

  const searchAbstract = async () => {
    if (!abstractNo) {
      notification.warn({ message: 'Enter abstract no.' })
      return
    }

    let { success, message, data } = await AbstractSearchById({ abstractNo })

    if (success) {
      // dispatch(getPushPathWrapper('abstractView', { id: data._id }))
      dispatch(getPushPathWrapper('onlineAbstractsGroup.viewAbstract', { id: data._id }))
      dispatch({ type: 'REFRESH_ABSTRACT', refreshAbstract: true })
    } else {
      setAbstractNo('')
      return
    }
    //dispatch({ type: 'STOP_LOAD_ABSTRACT' })
    //dispatch({ type: 'START_LOAD_ABSTRACT' })
  }

  const searchBtn = () => {
    return (
      <a onClick={() => searchAbstract()}>Go!</a>
    )
  }

  return (
    <React.Fragment>
      <div className={'searchBox'}>
        <Input
          className={'antInputSearch'}
          addonAfter={searchBtn()}
          value={abstractNo}
          placeholder={'Search your Abstract by Id'}
          onPressEnter={() => searchAbstract()}
          onChange={(e) => setAbstractNo(e.target.value)}
        />
      </div>
    </React.Fragment>
  )
}

export { AbstractSearch }